var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Theme from 'Theme';
var HamburgerMenu = function (props) {
    var width = "".concat(props.width || 20, "px"), height = "".concat(props.height || 16, "px"), halfHeight = "".concat(parseInt(height.replace('px', ''), 10) / 2, "px"), isOpen = props.isOpen || false, strokeWidth = props.strokeWidth || 2, halfStrokeWidth = "-".concat(strokeWidth / 2, "px"), animationDuration = props.animationDuration || 0.4;
    var getTransformValue = function (isOpened, defaultPos, rotateVal) { return ("translate3d(0,".concat(isOpened ? halfHeight : defaultPos, ",0) rotate(").concat(isOpened ? "".concat(rotateVal, "deg") : '0', ")")); };
    var container = {
        width: width,
        height: height,
        position: 'relative',
        transform: "rotate(".concat(props.rotate || 0, "deg)"),
    };
    var lineBase = {
        display: 'block',
        height: "".concat(strokeWidth, "px"),
        width: '100%',
        background: props.color || Theme.color.secondary,
        transitionTimingFunction: 'ease',
        transitionDuration: "".concat(animationDuration, "s"),
        borderRadius: "".concat(props.borderRadius || 0, "px"),
        transformOrigin: 'center',
        position: 'absolute'
    };
    var firstLine = {
        transform: getTransformValue(isOpen, 0, 45),
        marginTop: halfStrokeWidth,
    };
    var secondLine = {
        transitionTimingFunction: 'ease-out',
        transitionDuration: "".concat(animationDuration / 4, "s"),
        opacity: isOpen ? 0 : 1,
        top: halfHeight,
        marginTop: halfStrokeWidth
    };
    var thirdLine = {
        transform: getTransformValue(isOpen, height, -45),
        marginTop: halfStrokeWidth
    };
    return (React.createElement("div", { style: __assign(__assign({}, container), { margin: '10px' }), onClick: props.menuClicked },
        React.createElement("span", { style: __assign(__assign({}, lineBase), firstLine) }),
        React.createElement("span", { style: __assign(__assign({}, lineBase), secondLine) }),
        React.createElement("span", { style: __assign(__assign({}, lineBase), thirdLine) })));
};
export default HamburgerMenu;



//////////////////
// WEBPACK FOOTER
// ./src/components/NavBarMobile/HamburgerMenu.tsx
// module id = 1059
// module chunks = 0